// services/mengantar/mengantar-auth.ts — Mengantar client PER-BRAND via S2 proxy
// Semua call → `${getApiUrl()}/api/mengantar/{brandId}/{path}` (S2 resolve API key
// brand dari brand_settings.mengantarConfig). Secret TIDAK pernah masuk bundle browser.

import { getApiUrl, API_KEY } from '../apiConfig';
import { backendHeaders } from '../apiAuth';

export async function mengantarFetch(brandId: string, path: string, init?: RequestInit): Promise<Response> {
  const base: Record<string, string> = {};
  (new Headers(init?.headers || {})).forEach((v, k) => { base[k] = v; });
  const headers = new Headers(await backendHeaders(base, API_KEY));
  if (init?.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const url = `${getApiUrl()}/api/mengantar/${encodeURIComponent(brandId)}${path}`;
  return fetch(url, { ...init, headers });
}
